import React from "react";
import { Pagination, PaginationProps } from "react-admin";

export const DefaultPagintion = (props: PaginationProps) => (
  <Pagination rowsPerPageOptions={[25, 100, 500]} {...props} />
);
